// @ts-ignore
import CryptoJS from "crypto-js";

interface YzsFileServiceConfig {
  generateMate: () => Record<string, any>;
  generateHeaders: () => Record<string, string>;
  bizKey?: string;
  bizType?: string;
  basePrefix?: string;
  sysCode?: string;
  // baseDir?: string;
}

interface ApiResult<T = any> {
  success: boolean;
  code: string;
  msg: string;
  time: number;
  data: T | null;
}

interface UploadFileParams {
  file: File;
  onUploadProgress?: (
    progress: number,
    info: {
      file: File;
      progress: number;
      fileName: string;
      fileKey: string;
      fileUrl: string;
    }
  ) => void;
}

export default class YzsFileService {
  policyObject: any = null;
  basePolicyUrl = "/filemanager/client/http/policy";
  basePrefix = "";
  // baseDir = "";
  generateMate: () => Record<string, any>;
  generateHeaders: () => Record<string, string>;
  // ======================
  preContentType: any = null;

  bizKey = "";
  bizType = "";
  sysCode = "";

  constructor(config: YzsFileServiceConfig) {
    this.generateMate = config.generateMate;
    this.generateHeaders = config.generateHeaders;
    if (config.bizKey) {
      this.bizKey = config.bizKey;
    }
    if (config.bizType) {
      this.bizType = config.bizType;
    }
    if (config.basePrefix) {
      this.basePrefix = config.basePrefix.replace("/gw", "");
    }
    if (config.sysCode) {
      this.sysCode = config.sysCode;
    }
    // config.baseDir && (this.baseDir = config.baseDir);
  }

  apiPostPolicy(param: Record<string, any>): Promise<ApiResult> {
    const payload = {
      meta: {
        ...this.generateMate(),
        time: new Date().getTime(),
      },
      params: param,
    };
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open(
        "POST",
        window.location.origin + this.basePrefix + this.basePolicyUrl,
        true
      );
      xhr.setRequestHeader("content-type", "application/json");
      xhr.setRequestHeader("X-Request-From","YZSALL.harbour-portal-pc");
      if (this.generateHeaders) {
        const hearders = this.generateHeaders();
        Object.keys(hearders).forEach((v) => {
          xhr.setRequestHeader(v, hearders[v]);
        });
      }
      xhr.onload = function (e: ProgressEvent<EventTarget>) {
        let result: ApiResult = {
          success: false,
          code: "102",
          msg: "获取签名出错",
          time: new Date().getTime(),
          data: null,
        };
        try {
          // @ts-ignore
          result = JSON.parse((e.target as XMLHttpRequest).responseText);
        } catch (e) {
          resolve(result);
        }
        resolve(result);
      };
      xhr.send(JSON.stringify(payload));
    });
  }

  async getFileType(): Promise<ApiResult> {
    const payload = {
      meta: {
        ...this.generateMate(),
        time: new Date().getTime(),
      },
      params: {
        sysCode: this.sysCode,
        bizType: this.bizType,
      },
    };
    return new Promise<ApiResult>((resolve) => {
      const xhr = new XMLHttpRequest();
      xhr.open(
        "GET",
        window.location.origin +
          this.basePrefix +
          "/filemanager/client/http/config",
        true
      );
      xhr.setRequestHeader("content-type", "application/json");
      xhr.setRequestHeader("X-Request-From","YZSALL.harbour-portal-pc");
      if (this.generateHeaders) {
        const hearders = this.generateHeaders();
        Object.keys(hearders).forEach((v) => {
          xhr.setRequestHeader(v, hearders[v]);
        });
      }
      xhr.onload = function (e: ProgressEvent<EventTarget>) {
        let result: ApiResult = {
          success: false,
          code: "102",
          msg: "获取文件类型失败",
          time: new Date().getTime(),
          data: null,
        };
        try {
          // @ts-ignore
          result = JSON.parse((e.target as XMLHttpRequest).responseText);
        } catch (e) {
          resolve(result);
        }
        resolve(result);
      };
      xhr.send(JSON.stringify(payload));
    });
  }

  async uploadFile({ file, onUploadProgress }: UploadFileParams): Promise<any> {
    if (!file) {
      return Promise.resolve({ success: false, msg: "缺少上传文件" });
    }
    const dotIndex = file.name.lastIndexOf(".");
    const fileType = file.name.slice(dotIndex + 1, file.name.length);
    const fileMd5 = CryptoJS.MD5(file.name + file.size).toString();
    const param = {
      bizKey: this.bizKey,
      bizType: this.bizType,
      fileMd5: fileMd5,
      fileName: file.name,
      fileSize: file.size,
      fileType: fileType,
    };
    let result: any;
    result = await this.apiPostPolicy(param);
    if (!result.success) {
      return Promise.resolve(result);
    }
    result = await this.handleUpload(result, file, onUploadProgress, param);
    return Promise.resolve(result);
  }

  async handleUpload(
    res: any,
    file: File,
    onUploadProgress?: (
      progress: number,
      info: {
        file: File;
        progress: number;
        fileName: string;
        fileKey: string;
        fileUrl: string;
      }
    ) => void,
    param?: any
  ): Promise<any> {
    const formData = new FormData();
    res.data.forms.forEach((formItem: { key: string; value: string }) => {
      formData.append(formItem.key, formItem.value);
    });
    formData.append("file", file);
    return new Promise((resolve) => {
      const url = res.data.serverUrl;
      const xhr = new XMLHttpRequest();
      xhr.open("POST", url, true);
      xhr.setRequestHeader(
        "Authorization",
        localStorage.getItem("login-token") || ""
      );
      xhr.setRequestHeader("X-Request-From","YZSALL.harbour-portal-pc");
      xhr.upload.onprogress = function (e: ProgressEvent<EventTarget>) {
        if (!e.lengthComputable) return;
        const progress = Math.round((e.loaded / e.total) * 10000) / 100;
        if (onUploadProgress) {
          onUploadProgress(progress, {
            file: file,
            progress: progress,
            fileName: file.name,
            fileKey: param.fileMd5,
            fileUrl: res.data.fileUrl,
          });
        }
      };
      xhr.onload = function () {
        if (Math.floor(xhr.status / 100) === 2) {
          const value = {
            ...res,
            file: file,
            fileName: file.name,
            fileKey: param.fileMd5,
            fileUrl: res.data.fileUrl,
            data: res.data.fileUrl,
          };
          resolve(value);
        } else {
          resolve({
            success: false,
            msg: "文件 " + param.fileMd5 + " 上传失败，状态码：" + xhr.status,
          });
        }
      };
      xhr.onerror = function () {
        resolve({
          success: false,
          msg:
            "文件 " +
            param.fileMd5 +
            " 上传失败，请检查是否没配置 CORS 跨域规则",
        });
      };
      xhr.send(formData);
    });
  }

  camSafeUrlEncode(str: string): string {
    return encodeURIComponent(str)
      .replace(/!/g, "%21")
      .replace(/'/g, "%27")
      .replace(/\(/g, "%28")
      .replace(/\)/g, "%29")
      .replace(/\*/g, "%2A");
  }
}
